// Partner visits API (2026-10-06): see docs/superpowers/specs/2026-10-06-partner-visits-api-design.md

import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';
import { buildLaunchUrl } from '../../lib/partnerSuggestions';

// "Åpne i <vendor>" — one button per approved partner client the signed-in vet
// has consented to for this clinic. Hidden without an id and on closed journals.
// Spec: docs/superpowers/specs/2026-10-06-partner-visits-api-design.md §6.
@observer
class PartnerLaunchButtons extends Component {
    render() {
        const { stores, journal = {} } = this.props;
        const { journalStore, userStore } = stores;
        const launchers = journalStore.partnerLaunchers || [];
        if (launchers.length === 0 || !(journal.id > 0) || journal.closed) {
            return null;
        }
        const clinicId = userStore.customer ? userStore.customer.id : 0;
        const userId = userStore.user ? userStore.user.id : 0;
        const buttons = launchers.map(l => ({
            ...l,
            href: buildLaunchUrl(l.launchUrl, {
                visitId: journal.id, animalId: journal.animal, clinicId, userId,
            }),
        })).filter(l => l.href);
        if (buttons.length === 0) {
            return null;
        }
        return (
            <div class='d-flex flex-wrap gap-2 mx-2 my-2'>
                {buttons.map(l => (
                    <a
                        key={l.grantId}
                        class='btn btn-sm btn-outline-primary rounded-pill'
                        href={l.href}
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        {l.logoUrl
                            ? <img src={l.logoUrl} alt='' style='width: 16px; height: 16px; object-fit: contain;' class='me-1' />
                            : <i class='fa-solid fa-arrow-up-right-from-square me-1' />}
                        <Text id='dyrejournal.partner.open-in' fields={{ name: l.clientName }}>Open in {l.clientName}</Text>
                    </a>
                ))}
            </div>
        );
    }
}

export default PartnerLaunchButtons;
